enum EmpireSide {A = 'A', B = 'B', C = 'C', D = 'D'}

export default EmpireSide